import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { FunctionField } from 'shared/react-admin/Fields';
import { Merchant } from 'types/embedded/merchant';

type Props = {
  source?: string;
  label?: string;
};

export const MerchantsPartnersField: React.FC<Props> = () => {
  const translate = useTypedTranslate();

  return (
    <FunctionField
      render={({ partner }: Merchant) =>
        partner ? translate('app.common.yes') : translate('app.common.no')
      }
    />
  );
};
